import { fontData } from '../ui/fontData-sidecar'
import { IStevieText } from '../ui/stevieTexts'
import { stevieTexts } from '../ui/stevieTexts-sidecar'
import { deathPunchSounds } from './deathPunchSounds-sidecar'
import { deathPunch } from './deathPunch-sidecar'

interface IUiData {
  textTitle: IStevieText
  textAbout: IStevieText
  textIns: IStevieText
  textIns2: IStevieText
  textScore: IStevieText
  textSpeed: IStevieText
  textHp: IStevieText
  textAction: IStevieText
  textCredits: IStevieText
  textCredits2: IStevieText
  textCredits3: IStevieText
  textClickToFocus: IStevieText
}

let _data: IUiData | null
const getData = (): IUiData => {
  if (!_data) {
    let font32 = fontData.create('oryx_32px', {
      spaceWidth: 0,
      widthAdjust: 0,
    })
    let font24 = fontData.create('oryx_24px', { spaceWidth: 0, widthAdjust: 0 })
    let font16 = fontData.create('oryx_16px', { spaceWidth: 0, widthAdjust: 0 })

    let y = 30
    let x = 30

    let textTitle = stevieTexts.create(font32, x, y)
    stevieTexts.setText(textTitle, 'Audio Death Punch')
    y += 30

    let textClickToFocus = stevieTexts.create(font32, x, y + 200)
    stevieTexts.setText(textClickToFocus, 'Click to Give Game Focus')

    let textAbout = stevieTexts.create(font16, x, y)
    stevieTexts.setText(textAbout, 'an audio-only jam game by stevie bushman')

    y += 20

    let textIns = stevieTexts.create(font16, x + 30, y)
    stevieTexts.setText(
      textIns,
      'put on headphones -- click left to punch left -- right to punch right -- survive',
    )
    y += 20
    y += 20
    y += 20
    let textIns2 = stevieTexts.create(font16, x + 60, y)
    stevieTexts.setText(
      textIns2,
      'do not look at this screen! close your eyes and play blind -- this screen is for spectators only',
    )

    x += 60
    y = 200
    let textScore = stevieTexts.create(font24, x, y)
    stevieTexts.setText(textScore, 'Score: 0')

    y += 50
    let textHp = stevieTexts.create(font16, x, y)
    stevieTexts.setText(textHp, 'Hitpoints: 0')

    y += 50
    let textSpeed = stevieTexts.create(font16, x, y)
    stevieTexts.setText(textSpeed, 'Speed: 0')

    y += 50
    let textAction = stevieTexts.create(font16, x, y)
    stevieTexts.setText(textAction, 'Action: ?')

    y += 100
    let textCredits = stevieTexts.create(font16, x, y)
    stevieTexts.setText(
      textCredits,
      'Credits and attributions: https://audio-death-punch.keepflyinggames.com/',
    )
    y += 20
    let textCredits3 = stevieTexts.create(font16, x, y)
    stevieTexts.setText(
      textCredits3,
      'Programming and Design: Stevie Bushman - stevie at keepflyinggames.com',
    )
    y += 20
    let textCredits2 = stevieTexts.create(font16, x, y)
    stevieTexts.setText(textCredits2, 'Sfx: Oryx - Music: One Man Symphony')

    _data = {
      textTitle,
      textAbout,
      textIns,
      textIns2,
      textScore,
      textSpeed,
      textHp,
      textAction,
      textCredits,
      textCredits2,
      textCredits3,
      textClickToFocus,
    }
  }
  return _data as IUiData
}
export const create = () => {
  getData()
}

export const updateScore = (
  score: number,
  speed: number,
  hp: number,
  lastAction: string,
) => {
  let d = getData()

  let isClicked = deathPunch.getIntroClick()
  stevieTexts.setBulkVisible([d.textClickToFocus], !isClicked)
  stevieTexts.setBulkVisible(
    [
      // d.textIns,
      // d.textIns2,
      d.textScore,
      d.textAction,
      // d.textAbout,
      d.textHp,
      d.textSpeed,
    ],
    isClicked,
  )

  stevieTexts.setText(d.textScore, 'Score: ' + score)
  stevieTexts.setText(d.textHp, 'Hitpoints: ' + (hp || 'X.X'))

  stevieTexts.setText(d.textSpeed, 'Speed: ' + speed.toFixed(1))
  stevieTexts.setText(d.textAction, '' + lastAction)
}
